import React from 'react';

interface PhoneIconProps {
  className?: string;
  size?: number;
  color?: string;
}

const PhoneIcon: React.FC<PhoneIconProps> = ({
  className = '',
  size = 24,
  color = 'currentColor',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.21179 3C6.00531 3 7.32227 3.00006 8.12685 3.0001C8.5443 3.00012 8.91748 3.25945 9.06338 3.65058L10.1731 
      6.62538C10.2367 6.79573 10.2526 6.98018 10.2191 7.15888L9.61698 10.3757C10.3748 12.1692 11.6261 13.3748 13.7003 
      14.4562L16.8069 13.834C16.9918 13.797 17.1835 13.813 17.3597 13.8802L20.3564 15.0234C20.744 15.1712 21 15.543 21 
      15.9577V18.7528C21 20.1362 19.7901 21.2585 18.3741 20.9479C15.7947 20.383 11.0152 18.9459 7.66785 15.575C4.46069 
      12.3462 3.38601 7.88622 3.02525 5.47587C2.81825 4.09925 3.91406 3 5.21179 3Z"
      fill={color}
    />
  </svg>
);

export default PhoneIcon;
